/**
 * Los datos de mentira del comparador del Mapa SEO de la home.
 *
 * Viven aparte del componente porque son una TABLA, no marcado: 25 posiciones
 * por negocio, cinco negocios. Metidos en el JSX tapaban la estructura, y las
 * funciones que los resumen (media, balance) se pueden probar solas.
 *
 * Cada rejilla es una cuadrícula 5x5 leída por filas. El valor es el puesto en
 * el que sale ese negocio buscando desde ese punto. El centro NO es especial:
 * es un punto medido como los otros veinticuatro, igual que en el panel. Hubo
 * un `-1` ahí que servía para pintar un pin negro; ese pin no existe en
 * `GeoGridMap`, así que se fue y el centro pasó a llevar su puesto real.
 */

import { legendBuckets } from '@/lib/geogridScale';

/** Nuestra rejilla. El centro (índice 12) es el pin. */
export const MIA = [
  4, 2, 3, 8, 12,
  2, 1, 1, 5, 14,
  3, 1, 1, 7, 16,
  6, 2, 3, 10, 19,
  11, 8, 9, 15, 22,
];

export const RIVALES = [
  {
    clave: 'r1', inicial: '1', avBg: '#ede9fe', avFg: '#6d28d9',
    rejilla: [2, 5, 6, 4, 7, 6, 4, 3, 9, 8, 7, 5, 4, 11, 9, 3, 6, 8, 6, 11, 6, 4, 12, 9, 14],
  },
  {
    clave: 'r2', inicial: '2', avBg: '#dbeafe', avFg: '#1d4ed8',
    rejilla: [1, 3, 4, 2, 6, 4, 2, 2, 5, 7, 3, 3, 2, 6, 8, 2, 4, 5, 4, 9, 4, 3, 7, 6, 10],
  },
  {
    clave: 'r3', inicial: '3', avBg: '#fee2e2', avFg: '#b91c1c',
    rejilla: [7, 9, 8, 6, 11, 9, 8, 6, 12, 13, 10, 9, 8, 14, 15, 8, 10, 11, 9, 16, 12, 11, 14, 13, 18],
  },
  {
    clave: 'r4', inicial: '4', avBg: '#dcfce7', avFg: '#15803d',
    rejilla: [3, 6, 7, 5, 9, 7, 5, 4, 10, 11, 8, 6, 5, 12, 12, 5, 7, 9, 7, 13, 9, 6, 11, 10, 15],
  },
];

/**
 * El color de un puesto. Los cortes son los de Google: del 1 al 3 es el «pack
 * local», que es donde se decide la mayoría de las visitas, y por eso ese tramo
 * tiene su propio verde en vez de degradar suave desde el 1.
 */

/** Los siete colores de la leyenda, en el orden en que los explica la guía. */
/**
 * Los siete colores de la leyenda, sacados del MISMO módulo que pinta los
 * marcadores del panel (`legendBuckets`). Antes estaban escritos a mano aquí y
 * se habían separado de los del producto en cuatro de los siete: la landing
 * enseñaba una escala de color que no era la que el cliente se encuentra al
 * entrar. Ahora no pueden divergir.
 */
export const COLORES_LEYENDA = legendBuckets().map((b) => b.color);

/** Posición media, contando solo los puntos donde el negocio aparece. */
export function mediaRejilla(rejilla) {
  const visibles = rejilla.filter((n) => n > 0);
  if (visibles.length === 0) return '—';
  const media = visibles.reduce((a, b) => a + b, 0) / visibles.length;
  return media.toFixed(1).replace('.', ',');
}

/**
 * Cuántos puntos le ganamos, cuántos nos gana y cuántos empatamos.
 *
 * Solo cuentan los puntos donde APARECEN LOS DOS. Un punto donde el rival no
 * sale no es una victoria comparable: no sabemos en qué puesto habría salido.
 */
export function balanceCon(rejilla) {
  let gano = 0;
  let pierdo = 0;
  let empate = 0;

  MIA.forEach((mio, i) => {
    const suyo = rejilla[i];
    if (mio < 0 || suyo < 0) return;
    if (mio < suyo) gano += 1;
    else if (mio > suyo) pierdo += 1;
    else empate += 1;
  });

  return { gano, pierdo, empate, total: gano + pierdo + empate };
}
